import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "button"]

  copy() {
    const text = this.sourceTarget.textContent || this.sourceTarget.value
    navigator.clipboard.writeText(text).then(() => {
      const original = this.buttonTarget.textContent
      this.buttonTarget.textContent = "Copiado!"
      setTimeout(() => { this.buttonTarget.textContent = original }, 2000)
    })
  }
}
